import { ParsedSale, ParsedSaleData } from '../types/ParsedObjects'
import { Sale, SaleData } from '../types/Sale'
import { parseProducts } from './parseProducts'

const DTOSale = (sale: Sale): ParsedSale => {
  return {
    ...sale,
    vendorSku: sale.products.edges.map(({ node }) => node.vendorSku).join(', '),
    products: parseProducts(sale.products),
    imageUrl: sale.imageCollection?.showcaseImage.url
  }
}

const DTOSaleData = (sale: SaleData): ParsedSaleData => {
  const {
    retail_price,
    main_image,
    active_at,
    expires_at,
    promotion_percentage,
    ...remainder
  } = sale

  return {
    ...remainder,
    retailPrice: sale.retail_price,
    mainImage: sale.main_image,
    activeAt: sale.active_at,
    expiresAt: sale.expires_at,
    promotionPercentage: sale.promotion_percentage
  }
}

export { DTOSale, DTOSaleData }
